import axios from '@/api/axios';

const host = window.location.hostname;
let baseURL = process.env.VUE_APP_BACKOFFICE_URL ?? `https://public.${host}/`;
if (host.includes('webplayer') && !host.includes('testing')) {
  baseURL = `https://public.${host.replace('webplayer.', '')}/`;
}

//auth
export const guidLogin = (credentials) => {
  return axios.post(baseURL + 'api/public/guidLogin', credentials);
};

export const getTrialMovie = (id) => {
  return axios.post(baseURL + `api/public/getMovie?id=${id}`);
};

export const getBrandConfig = () => {
  return axios.post(baseURL + 'api/public/getBrandConfig');
};

export const leadSignup = ({ guid, leadId, payload, captchaToken }) => {
  return axios.post(baseURL + `api/public/leadSignup`, {
    guid,
    leadId,
    payload,
    captchaToken,
  });
};

export const sendPhoneVerificationCodeByGuid = ({ guid, leadId, phone, channel, captchaToken }) => {
  return axios.post(baseURL + `api/public/sendPhoneVerificationCodeByGuid`, {
    guid,
    leadId,
    phone,
    channel,
    captchaToken,
  });
};

export const getLcWidget = (brand) => {
  return axios.get(baseURL + `api/public/getLcWidget?brand=${brand}`);
};

export const magicLinkLogin = (token) => axios.post(baseURL + 'api/public/magicLinkLogin', { token });

export const clientMessages = (token) =>
  axios.post(baseURL + 'api/public/getClientMessages', {
    wpToken: token,
    platform: 'webplayer',
  });

export const readMessage = (token, messageId) => axios.post(baseURL + 'api/public/readMessage', { wpToken: token, messageId });

export const updateWatchTimeMovie = (imdb_id, seconds) => axios.put(`/api/history/movie/position/${imdb_id}/${seconds}`);
export const getMovie = (id) => axios.get(`/api/info/movies/${id}`);

export const updateWatchTimeSportsVod = (imdb_id, seconds) => axios.put(`/api/event/history/position/${imdb_id}/${seconds}`);
export const getSportsVod = (id) => axios.get(`/api/event/${id}`);

export const updateWatchTimeTvShow = (imdb_id, seconds, episode, season, looks_watched) => axios.put(`/api/history/tvshow/position/${imdb_id}/${season}/${episode}/${seconds}/${looks_watched}`);
export const getTvShow = (id) => axios.get(`/api/info/tvshow/${id}`);

export const updateWatchedTimeLiveTv = (imdb_id, seconds) => axios.put(`/api/history/livetv/position/${imdb_id}/${seconds}`);

export const watchLinkLogin = (token) => axios.post(baseURL + 'api/public/watchLinkLogin', { token });

export const updateLead = (leadId, guid, minutesUpdate) => axios.post(baseURL + 'api/public/updateLead', { leadId, guid, minutesUpdate });
